// Granola (03/11/2026): the notes of the person's meetings that came from Granola, and the ones waiting for a customer.
export default {
  granola: {
    title: 'Gravações',
    subtitle: 'Cada anotação que a Granola termina vira uma tarefa no cliente. As que não achamos o cliente esperam aqui.',
    shortcuts: { unlinked: 'Não vinculadas', linked: 'Vinculadas', dismissed: 'Descartadas', all: 'Todas' },
    searchPlaceholder: 'Título, cliente ou participante',
    count: 'Nenhuma anotação | 1 anotação | {n} anotações',
    notConnectedTitle: 'Conecte a sua conta da Granola',
    notConnectedText: 'Cole a sua chave de API em Integrações. Cada pessoa usa a própria conta.',
    goToIntegrations: 'Abrir Integrações',
    emptyUnlinked: 'Nenhuma anotação esperando cliente.',
    emptyUnlinkedText: 'Quando a Granola terminar uma anotação que não conseguimos ligar a um cliente, ela aparece aqui.',
    empty: 'Nenhuma anotação ainda.',
    emptyText: 'As anotações chegam aqui quando a Granola termina de gerar o resumo.',
    columns: { title: 'Anotação', when: 'Reunião', duration: 'Duração (prevista)', customer: 'Cliente', status: 'Situação' },
    status: { pending: 'Lendo', linked: 'Vinculada', unlinked: 'Sem cliente', dismissed: 'Descartada', failed: 'Falhou' },
    minutes: '{n} min',
    hoursMinutes: '{h}h{m}',
    noCustomer: 'Sem cliente',
    linkedBy: 'Vinculada por {who}',
    auto: 'automaticamente',
    link: 'Vincular',
    dismiss: 'Descartar',
    retry: 'Tentar de novo',
    openTask: 'Abrir a tarefa',
    openNote: 'Abrir na Granola',
    reasonPrefix: 'Por que não vinculou: ',
    dismissed: 'Anotação descartada.',
    retried: 'Vou ler a anotação de novo.',
    linkedToast: 'Anotação vinculada e tarefa criada.',
    dialog: {
      title: 'Vincular anotação',
      text: 'Escolha o cliente. Criamos a tarefa nele com o resumo da Granola.',
      customer: 'Cliente',
      project: 'Projeto (opcional)',
      none: 'Nenhum',
      cancel: 'Cancelar',
      confirm: 'Vincular e criar a tarefa',
      chooseCustomer: 'Escolha o cliente.',
    },
    summary: 'Resumo',
    attendees: 'Participantes',
  },
}
